import { BsArrowRight } from "react-icons/bs";
import { Link } from "react-scroll";

const Home = () => {
  return (
    <section className="container home">
      <div className="grid">
        <div className="home__content">
          <h2 className="medium-text">Hi, I'm Ghulam 👋</h2>
          <h1 className="home__title large-text mb-1">A Software Developer</h1>
          <p className="small-text mb-5">
            I have 1+ year experience working as a software developer. my tech
            stack are Java,..etc.
          </p>
          <Link to="project" smooth={true} className="btn">
            See My Works <BsArrowRight />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Home;
